import { axiosInstance } from 'api/apiConfig'
import { useQuery, useMutation } from 'react-query'

const rcmmKeywordList = async (params) => {
  const { data } = await axiosInstance.post('/api/main/menusearch/v1.0/menuRtrvRcmmKwrdNmList', params)
  return data
}

// 추천키워드
export const useRcmmKeywordList = (params, isInit) => {
  return useQuery(['rcmmKeywordList'], () => rcmmKeywordList(params), {
    enabled: isInit,
  })
}


const allRtrvList = async (params) => {
  const { data } = await axiosInstance.post('/api/main/menusearch/v1.0/allRtrv', params)
  return data
}

// 전체검색
export const useAllRtrvList = (params, isInit) => {
  return useQuery(['allRtrvList'], () => allRtrvList(params), {
    enabled: isInit,
  })
}



const menuRtrvTabList = async (params) => {
  const { data } = await axiosInstance.post('/api/main/menusearch/v1.0/menuRtrvTab', params)
  return data
}

// 탭검색
export const useMenuRtrvTabList = (params, isInit) => {
  return useQuery(['menuRtrvTabList'], () => menuRtrvTabList(params), {
    enabled: isInit,
  })
}

const menuRtrvTabPage = async (params) => {
  const { data } = await axiosInstance.post('/api/main/menusearch/v1.0/menuRtvTabPage', params)
  return data
}

// 탭 더보기
export const useMenuRtrvTabPage = (params, isInit) => {
  return useQuery(['menuRtrvTabPage'], () => menuRtrvTabPage(params), {
    enabled: isInit,
  })
}

//메뉴 즐겨찾기
const menuFrvtUpdate = async (params) => {
  const { data } = await axiosInstance.put('/api/main/menusearch/v1.0/setMenuRtrvMenuFrvt', params);
  return data;
};

export const useMenuFrvtUpdate = ({
  successHandler,
  errorHandler,
}) => {
  return useMutation((params) => menuFrvtUpdate(params), {
    onSuccess: (res, data) => {
      successHandler(res, data);
    },
    onError: (error) => {
      errorHandler(error);
    },
  });
};

// 메뉴분류 코드 조회
const menuClsnCdList = async (params) => {
  const { data } = await axiosInstance.post('api/menu/standard/v1.0/selectMenuClsnCdLst',params)
  return data
}


export const useMenuClsnCdList = (params, isInit) => {
  return useQuery(
    ['menuClsnCdList'],
    () => menuClsnCdList(params),
    {
      enabled: isInit,
    },
  )
}